
<template>
  <div id="wrapper">
    <!-- Navigation -->
    <nav class="navbar navbar-inverse navbar-fixed-top" :style="{backgroundColor: navbarBackgroundColor}" role="navigation">
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle"
          data-toggle="collapse"
          data-target=".navbar-ex1-collapse"
        >
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <span class="navbar-brand mb-0 h1">ezyCommerce Admin Portal <span class="env-name">{{'(' + environmentName + ')'}}</span></span>
      </div>
      <!-- Top Menu Items -->
      <MainHeader v-if="isLoggedIn" />
      <!-- Sidebar Menu Items - These collapse to the responsive navigation menu on small screens -->
      <SectionMenu v-if="isLoggedIn" />
      <!-- /.navbar-collapse -->
    </nav>

    <div id="page-wrapper">
      <div class="container-fluid">
        <!-- Page Heading -->
        <div class="row" id="main">
          <MessageContainer />
          <button class="login-button btn btn-primary" v-if="!isLoggedIn" @click="login">
            Login
          </button>

          <div v-if="isLoggedIn">
            <Login v-if="false" />
            <button v-if="showHistoryButton" @click="showHistoryRecords" class="btn btn-primary pull-right history-button">History</button>
            <router-view />
            <RestoreDataModal />
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /#page-wrapper -->
  </div>
  <!-- /#wrapper -->
</template>

<script>
import { mapGetters } from 'vuex'
import Login from './Login'
import MainHeader from './MainHeader'
import MessageContainer from './MessageContainer'
import identityHandler from '@/core/identity-handler'
import SectionMenu from './SectionMenu'
import RestoreDataModal from './RestoreDataModal'
import { routesNames, sectionsNames } from '@/core/constants'

export default {
  created() {
    identityHandler.getProfile().then(response => {
      if (!response) {
        return
      }
      this.$store.commit('setLogin', {
        username: response.name,
        tenant: response.tenant
      })
    })

    identityHandler.isAdmin().then(response => {
      if (!response) {
        return
      }
      this.$store.commit('setIsAdmin', response)
    })
  },
  computed: {
    ...mapGetters(['currentSection', 'isLoggedIn', 'isAdmin', 'auditLogSelected']),
    showHistoryButton() {
      return this.currentSection && this.$route.name === routesNames.valueEditor
    },
    environmentName() {
      return window.runtimeConfig.environmentName
    },
    navbarBackgroundColor() {
      return window.runtimeConfig.navbarBackgroundColor
    }
  },
  methods: {
    login() {
      this.$store.commit('login')
    },
    showHistoryRecords() {
      this.$router.push({name: 'History'})
    }
  },
  watch: {
    currentSection(val, oldVal) {
      if (val.displayName === sectionsNames.auditLogs) {
        if (this.$route.name !== routesNames.auditLogs) this.$router.push({name: 'AuditLogs'})
        return
      }

      if (this.auditLogSelected) {
        this.$router.push({name: 'History'})
        this.$store.commit('clearAuditLogSelected')
        return
      }

      if (this.$route.name !== routesNames.valueEditor) this.$router.push({name: 'ValueEditor'})
    }
  },
  components: {
    Login,
    MainHeader,
    MessageContainer,
    SectionMenu,
    RestoreDataModal
  }
}
</script>

<style>
@import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css");
@media (min-width: 768px) {
  body {
    margin-top: 50px;
  }
  /*html, body, #wrapper, #page-wrapper {height: 100%; overflow: hidden;}*/
}

#wrapper {
  padding-left: 0;
}

#page-wrapper {
  width: 100%;
  padding: 135px 0 0 0;
  background-color: #fff;
}

@media (min-width: 768px) {
  #wrapper {
    padding-left: 300px;
  }

  #page-wrapper {
    padding: 22px 10px;
  }
}

/* Top Navigation */

.top-nav {
  padding: 0 15px;
}

.top-nav > li {
  display: inline-block;
  float: left;
}

.top-nav > li > a {
  min-height: 60px;
  color: #fff;
}

.top-nav > li > a:hover,
.top-nav > li > a:focus,
.top-nav > .open > a,
.top-nav > .open > a:hover,
.top-nav > .open > a:focus {
  color: #fff;
  background-color: #1a242f;
}

.top-nav > .open > .dropdown-menu {
  float: left;
  position: absolute;
  margin-top: 0;
  /*border: 1px solid rgba(0,0,0,.15);*/
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  background-color: #fff;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
}

.top-nav > .open > .dropdown-menu > li > a {
  white-space: normal;
}

/* Side Navigation */

@media (min-width: 768px) {
  .side-nav {
    position: fixed;
    top: 60px;
    left: 300px;
    width: 300px;
    margin-left: -300px;
    border: none;
    border-radius: 0;
    border-top: 1px rgba(0, 0, 0, 0.5) solid;
    overflow-y: auto;
    background-color: #222;
    /*background-color: #5A6B7D;*/
    bottom: 0;
    overflow-x: hidden;
    padding-bottom: 40px;
  }

  .side-nav > li > a {
    width: 300px;
    border-bottom: 1px rgba(0, 0, 0, 0.3) solid;
  }

  .side-nav li a:hover,
  .side-nav li.active {
    outline: none;
    background-color: #337ab7 !important;
  }
}

.side-nav li > ul {
  padding: 0;
  list-style-type: none;
  border-bottom: 1px rgba(0, 0, 0, 0.3) solid;
}

.side-nav li > ul > li > ul {
  padding-left: 10px;
  list-style-type: none;
  border-bottom: 1px rgba(0, 0, 0, 0.3) solid;
}

.side-nav li > ul > li > a {
  display: block;
  padding: 10px 15px 10px 38px;
  text-decoration: none;
  /*color: #999;*/
  color: #fff;
}

.side-nav > li > ul > li > a:hover {
  color: #fff;
}

.navbar .nav > li > a > .label {
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  position: absolute;
  top: 14px;
  right: 6px;
  font-size: 10px;
  font-weight: normal;
  min-width: 15px;
  min-height: 15px;
  line-height: 1em;
  text-align: center;
  padding: 2px;
}

.navbar .nav > li > a:hover > .label {
  top: 10px;
}

.navbar-inverse .navbar-brand {
  height: 30px;
  color: #fff;
  font-size: 20px;
  padding: 0px 20px;
}

.navbar-inverse .navbar-brand .env-name {
  font-size: 14px;
}

.login-button {
  margin: 0 auto;
  display: block;
}

@media (max-width: 768px) {
  .h1 {
    margin-top: 10px;
    margin-bottom: 0;
  }

  .history-button {
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue